// extracted by mini-css-extract-plugin
module.exports = {"buttonContainer":"styles_buttonContainer__A7W8a","leftArrow":"styles_leftArrow__EMQir"};